import { ApiResult } from "@/interfaces/api.interface";
import { CheckExist } from "@/interfaces/common.interface";
import {
  GroupModel,
  GyoushuModel,
  KaishaModel,
  QueryGroup,
  QueryKaisha,
} from "@/interfaces/kaisha.interface";
import request from "@/utils/request";
import { AxiosPromise } from "axios";

// 会社関連
export function getKaishaList(
  params: QueryKaisha
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `kaisha/getList`,
    params,
    method: "get",
  });
}

export function getKaishaById(id: number): AxiosPromise<ApiResult<any>> {
  return request({
    url: `kaisha/getById/${id}`,
    method: "get",
  });
}

export function checkKaisha(params: CheckExist): AxiosPromise<ApiResult<any>> {
  return request({
    url: `kaisha/checkKaishaCdExist`,
    method: "get",
    params,
  });
}

export function createKaisha(
  data: Omit<KaishaModel, "id" | "mukoDate" | "mukoFlg">
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `kaisha/create`,
    method: "post",
    data,
  });
}

export function updateKaisha(
  id: number,
  data: Pick<KaishaModel, "kaishaNm" | "unyoCd" | "gyoushuCd" | "mukoFlg">
): AxiosPromise<ApiResult<any>> {
  console.log(data);
  return request({
    url: `kaisha/update/${id}`,
    method: "patch",
    data,
  });
}

// 会社グループ関連
export function getGroupList(params: QueryGroup): AxiosPromise<ApiResult<any>> {
  return request({
    url: `kaishaGroup/getList`,
    params,
    method: "get",
  });
}

export function getGroupById(id: number): AxiosPromise<ApiResult<any>> {
  return request({
    url: `kaishaGroup/getById/${id}`,
    method: "get",
  });
}

export async function checkKaishaUnyo(kaishaCd: string): Promise<number> {
  const res = await request({
    url: `kaishaGroup/checkKaishaUnyo/${kaishaCd}`,
    method: "get",
  });
  return res.data.result;
}

export function createGroup(
  data: Pick<GroupModel, "groupNm" | "kaishaCd">
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `kaishaGroup/create`,
    method: "post",
    data,
  });
}

export function updateGroup(
  id: number,
  data: Pick<GroupModel, "groupNm" | "mukoFlg">
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `kaishaGroup/update/${id}`,
    method: "patch",
    data,
  });
}

// 業種分類関連
export function getGyoushuList(): AxiosPromise<ApiResult<any>> {
  return request({
    url: `gyoushu/getList`,
    method: "get",
  });
}

export function getGyoushuById(id: number): AxiosPromise<ApiResult<any>> {
  return request({
    url: `gyoushu/getById/${id}`,
    method: "get",
  });
}

export function checkGyoushuCd(
  params: CheckExist
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `gyoushu/checkGyoushuCdExist`,
    method: "get",
    params,
  });
}

export function createGyoushu(
  data: Pick<GyoushuModel, "gyoushuCd" | "gyoushuNm">
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `gyoushu/create`,
    method: "post",
    data,
  });
}

export function updateGyoushu(
  id: number,
  data: Pick<GyoushuModel, "gyoushuNm">
): AxiosPromise<ApiResult<any>> {
  return request({
    url: `gyoushu/update/${id}`,
    method: "patch",
    data,
  });
}
